import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wallet, QrCode, Storefront, Trophy, User } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const items = [
    { path: '/wallet', icon: Wallet, labelFr: 'Carte', labelEn: 'Card' },
    { path: '/scanner', icon: QrCode, labelFr: 'Scanner', labelEn: 'Scan' },
    { path: '/explore', icon: Storefront, labelFr: 'Réseau', labelEn: 'Network' },
    { path: '/rewards', icon: Trophy, labelFr: 'Récompenses', labelEn: 'Rewards' },
    { path: '/profile', icon: User, labelFr: 'Profil', labelEn: 'Profile' }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-[#18261E]/95 backdrop-blur-lg border-t border-[#283D32] z-[9999]" style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 8px)' }}>
      <div className="flex justify-around py-2">
        {items.map((item) => {
          const Icon = item.icon;
          const active = location.pathname === item.path;
          const label = language === 'fr' ? item.labelFr : item.labelEn;
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center py-2 px-4 relative"
              data-testid={`nav-${item.path.replace('/', '')}`}
            >
              {active && (
                <motion.div
                  layoutId="nav-indicator"
                  className="absolute -top-0.5 w-8 h-0.5 bg-[#C3A365] rounded-full"
                />
              )}
              <Icon 
                size={22} 
                weight={active ? 'fill' : 'regular'} 
                className={active ? 'text-[#C3A365]' : 'text-[#8BA89A]'}
              />
              <span className={`text-[10px] mt-1 ${active ? 'text-[#C3A365]' : 'text-[#8BA89A]'}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
